import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Route, Router, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux'; // Desarrollo
// import { applyMiddleware, createStore } from 'redux';       // Producción
import reduxThunk from 'redux-thunk';
import { Helmet } from 'react-helmet';
import './i18n';
import './index-base.css';
import App from './components/App';
import RedirIdioma from './components/common/RedirIdioma';
import Portada from './components/blog/Portada';
import Articulo from './components/blog/Articulo';
import reducers from './reducers';
import RefreshMiddleware from './middlewares/RefreshMiddleware'; // Para refrescar el access token cuando vaya a caducar
import CargadorSuspense from './components/common/CargadorSuspense';
import history from './history';

// Producción
let store = createStore(reducers, {}, applyMiddleware(reduxThunk, RefreshMiddleware));
if (process.env.NODE_ENV === 'development') {
  // Desarrollo
  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  store = createStore(reducers, {}, composeEnhancers(applyMiddleware(reduxThunk, RefreshMiddleware))); // El segundo argumento, los {}, se podría utilizar para pasar un estado inicial a Redux
}

// Tengo que hacer un Cargador específico para el Suspense ya que no puedo meter en el traducciones
// Puedo hacer un cargador sin traducciones
// Puedo hacer un cargador sin traducciones para el Suspense y otro para el resto de la web (usado con el checkStatusEnApi)
// O bien puedo hacer <Suspense fallback={null}> y que no salga nada
// O bien poner en el archivo i18n.js useSuspense: false
ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Suspense fallback={<CargadorSuspense />}>
        <Helmet>
          <title>Blog de administración de sistemas y programación | Antarie</title>
          <meta content="Soluciones de software, diseño de páginas web, desarrollo de aplicaciones para móviles, AI & Machine Learning, transformación digital, migración a la nube..." name="description" />
          <meta content="software, paginas, web, apps, aplicaciones, ios, android, inteligencia, artificial. machine, learning, react, native, express, python, symfony, mongo, node, linux, mysql, docker, cloud, nube" name="Keywords" />
        </Helmet>
        <App>
          <Switch>
            <Route component={RedirIdioma} exact path="/" />
            <Route component={Portada} exact path="/:idioma" />
            <Route component={Articulo} exact path="/:idioma/:articulo_slug" />
          </Switch>
        </App>
      </Suspense>
    </Router>
  </Provider>,
  document.querySelector('#root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
